import { Component } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
  selector: 'app-viagens-aereo',
  templateUrl: './viagens-aereo.component.html',
  styleUrl: './viagens-aereo.component.css'
})
export class ViagensAereoComponent {

  item: any = {
    fornecedor: '',
    qtdEntregas: 0,
    horarios: [],
    pontoDescarga: ''
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  tabelaVeiculos: string = 'veiculos_fluxo_aereo';
  queryCarriers: string = 'Carriers';
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  startDate!: Date;
  endDate: Date = new Date();
  dialogOpen!: boolean;
  isLoading: boolean = true;
  tabelaDia: boolean = false;
  clickedButtons: { [key: string]: boolean } = { 'seg': true };
  diaSelect: string = 'seg';
  totalMU: number = 0;
  totalFornecedores: number = 0;
  viagens: any[] = [];
  viagensFiltradas: any[] = [];
  edit: boolean = false;
  veiculos!: any[];
  usuarioLogado: any;
  carriers: any[] = [];


  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private servicoAutenticacao: AutenticacaoService

  ) { }

  async ngOnInit() {
    await this.getUserLogado();
    await this.getVeiculosFromDynamoDB();
    await this.getCarriers();
    await this.upDate();
  }

  async upDate() {
    await this.getProgramacaoDiretasFromDynamoDB();
    this.isLoading = false;
  }

  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  inserirPlaca() {
    this.item = [];
    if (this.viagensFiltradas.some(item => item.selecionado)) {
      this.dialogOpen = true;
    } else {
      window.alert("Nenhum processo selecionado!")
    }
  }

  editDialog(item: any): void {
    this.edit = true;
    this.item = { ...item }
    this.dialogOpen = true;
  }

  updateHorarios() {
    const qtd = parseInt(this.item.qtdEntregas, 10) || 0;
    this.item.horarios = new Array(qtd).fill({}).map((_, i) => ({ hora: '' }));
  }

  removerHorario(index: number) {
    this.item.horarios.splice(index, 1);
  }


  findVeiculoByModelo(viagensComPlaca: any) {
    // if (Array.isArray(viagensComPlaca)) {
    //   viagensComPlaca.forEach(item => {
    //     item.capacidadePeso = item.capacidadePeso ? item.capacidadePeso : this.veiculos.find(veiculo => veiculo.placa == item.Plate) ? this.veiculos.find(veiculo => veiculo.placa == item.Plate).peso : 0
    //     item.capacidadeVolumetrica = item.capacidadeVolumetrica ? item.capacidadeVolumetrica : this.veiculos.find(veiculo => veiculo.placa == item.Plate) ? this.veiculos.find(veiculo => veiculo.placa == item.Plate).volume : 0
    //     item.veiculoPerfil = item.veiculoPerfil ? item.veiculoPerfil : this.veiculos.find(veiculo => veiculo.placa == item.Plate) ? this.veiculos.find(veiculo => veiculo.placa == item.Plate).perfil : 'Não encontrado'
    //     item.emissao = item.emissao ? item.emissao : this.veiculos.find(veiculo => veiculo.placa == item.Plate) ? this.veiculos.find(veiculo => veiculo.placa == item.Plate).emissoes : 0
    //     item.consumo = item.consumo ? item.consumo : this.veiculos.find(veiculo => veiculo.placa == item.Plate) ? this.veiculos.find(veiculo => veiculo.placa == item.Plate).consumo : 0
    //     item.emissaoTotal = item.emissaoTotal ? item.emissaoTotal : (item['Total Distance'] * item.emissao) / item.consumo;
    //   })
    // } else {
    return (
      viagensComPlaca['Transport Type'] = viagensComPlaca['Transport Type'] && viagensComPlaca['Transport Type'] != '' ? viagensComPlaca['Transport Type'] : this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate) ? this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate).modelo : '',
      viagensComPlaca.capacidadePeso = viagensComPlaca.capacidadePeso ? viagensComPlaca.capacidadePeso : this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate) ? this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate).peso : 0,
      viagensComPlaca.capacidadeVolumetrica = viagensComPlaca.capacidadeVolumetrica ? viagensComPlaca.capacidadeVolumetrica : this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate) ? this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate).volume : 0,
      viagensComPlaca.veiculoPerfil = viagensComPlaca.veiculoPerfil ? viagensComPlaca.veiculoPerfil : this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate) ? this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate).perfil : 'Não encontrado',
      viagensComPlaca.emissao = viagensComPlaca.emissao ? viagensComPlaca.emissao : this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate) ? this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate).emissoes : 0,
      viagensComPlaca.consumo = viagensComPlaca.consumo ? viagensComPlaca.consumo : this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate) ? this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate).consumo : 0,
      viagensComPlaca.emissaoTotal = viagensComPlaca.emissaoTotal ? viagensComPlaca.emissaoTotal : (viagensComPlaca['Total Distance'] * viagensComPlaca.emissao) / viagensComPlaca.consumo
      // console.log(this.veiculos.find(veiculo => veiculo.placa == viagensComPlaca.Plate))
      // }
    )
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.tabelaVeiculos, this.urlConsulta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items;
            // console.log(this.veiculos)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

    async getCarriers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryCarriers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items;
              // console.log(this.carriers)
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.carriers')
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async salvar2(item: any) {
    this.isLoading = true;
    this.item = { ...item };
    this.item['Total Distance'] = this.item.aeroporto == 'VCP' ? 150 : 60;
    // this.findVeiculoByModelo(this.item);
    try {
      const itemsDataString = JSON.stringify(this.item);
      const modifiedString = itemsDataString.replace(/\\"/g, '"');
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      const modifiedJsonString = JSON.stringify(jsonObject);
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, 'fluxoAereo', this.urlAtualiza).subscribe({
        next: () => {
          this.upDate();
          this.edit = false;
          this.dialogOpen = false;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Erro ao salvar programação:', err);
          this.isLoading = false;
        }
      });
    } catch {
    }
  }

  async salvarNoBanco() {
    this.isLoading = true;
    const viagensComPlaca = this.viagensFiltradas.filter(item => {
      return item.selecionado === true
    })
    viagensComPlaca.forEach(async viagem => {
      return (
        viagem.tableName = 'fluxoAereo',
        viagem.motorista = this.item.motorista,
        viagem.Plate = this.item.Plate,
        viagem.transportadora = this.item.transportadora,
        viagem['Total Distance'] = viagem.aeroporto == 'VCP' ? 150 : 60,
        viagem.selecionado = false
        // await this.findVeiculoByModelo(viagem)
      )
    })
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(viagensComPlaca, batchSize); // Fraciona o jsonData em lotes menores
    for (const batch of batches) {
      // console.log(batch)
      this.dynamodbService.salvar(batch, 'fluxoAereo', this.urlAtualiza).subscribe({
        next: () => {
          console.log('Programação salva com sucesso.');
          this.edit = false;
          this.dialogOpen = false;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Erro ao salvar programação:', err);
          this.isLoading = false;
        }
      });
    }
  }

  async finalizarViagem() {
    this.item = [];
    if (this.viagensFiltradas.some(item => item.selecionado)) {
      await this.finalizarViagemNoBanco();
    } else {
      window.alert("Nenhum processo selecionado!")
    }
  }

  async finalizarViagemNoBanco(): Promise<void> {
    this.isLoading = true;
    const selecionadas = this.viagensFiltradas.filter(item => {
      return item.selecionado === true
    })
    selecionadas.forEach(async viagem => {
      return (
        viagem.tableName = 'fluxoAereo',
        viagem.finalizada = true,
        viagem.selecionado = false
        // await this.findVeiculoByModelo(viagem)
      )
    })
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(selecionadas, batchSize); // Fraciona o jsonData em lotes menores
    for (const batch of batches) {
      // console.log(batch)
      this.dynamodbService.salvar(batch, 'fluxoAereo', this.urlAtualiza).subscribe({
        next: async () => {
          console.log('Programação salva com sucesso.');
          this.edit = false;
          this.dialogOpen = false;
          await this.upDate();
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Erro ao salvar programação:', err);
          this.isLoading = false;
        }
      });
    }
  }

  cancel(): void {
    this.dialogOpen = false;
  }

  async getProgramacaoDiretasFromDynamoDB(): Promise<void> {
    const lambdaEvent = {
      "tableName": 'fluxoAereo',
      "searchConditions": [
        // { "column": "status", "word": "Completed", "negate": true },
        // { "column": "status", "word": "Canceled", "negate": true },
        { "column": "finalizada", "word": "true", "negate": true },
        // { "column": "Finalizada", "word": "True", "negate": true },
        // { "column": "ID", "word": "", "negate": true }
      ]
    };
    const response: any = await new Promise(async (resolve, reject) => {
      (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
        (res: any) => resolve(res),
        (error: any) => reject(error)
      );
    });
    if (response.statusCode == 200) {
      try {
        const items = await JSON.parse(response.body);
        if (Array.isArray(items)) {
          this.viagens = items;
          this.viagensFiltradas = this.viagens.filter(item => {
            return (item.finalizada != true);
          });
          // console.log(this.viagensFiltradas)
          this.viagensFiltradas.sort((a, b) => new Date(b.chegada).getTime() - new Date(a.chegada).getTime());
        } else {
          console.error('Invalid items data:', items);
        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    } else {
      console.error('Invalid response:', response);
    }
  }

  async deleteItem(Item: any): Promise<void> {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = true;
        const ID = Item.ID;
        await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
          async response => {
            await this.upDate();
            this.dialogOpen = false;
            this.isLoading = false;
          },
          error => {
            // Lógica para lidar com erros durante a deleção do item
          }
        );
      }
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async getUserLogado() {
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
  }
}
